import { memo } from 'react';
import { Box, Stack, styled, useTheme } from '@mui/material';
import MaxWidthContainer from '../../atoms/MaxWidthContainer';
import Grid from '@mui/material/Unstable_Grid2';
import Image, { makeDataTestId as imageMakeDataTestId } from '../../atoms/Image';

const HeaderContainer = styled(Box)<{ sticky?: string }>(
  ({ theme }) => `
  color: ${theme.partner.header.color};
  background-color: ${theme.partner.header.backgroundColor};

  border-bottom: 1px solid ${theme.palette.grey['300']}
  `,
);

const HeaderGrid = styled(Grid)(
  ({ theme }) => `
  height: ${theme.partner.header.height ?? '3.625rem'};
  `,
);

const LogoGrid = styled(Grid)`
  display: flex;
  align-items: center;
`;

const PartnerLogo = styled(Image)(
  ({ theme }) => `
  img {
    height: 2rem;
    max-height: ${theme.partner.header.logoMaxHeight};
    max-width: ${theme.partner.header.logoMaxWidth};
  }
`,
);

export const makeDataTestId = (dataTestId = 'header') => {
  return {
    prefix: dataTestId,
    wrapper: `${dataTestId}.wrapper`,
    backButton: `${dataTestId}.backButton`,
    logo: imageMakeDataTestId(`${dataTestId}.logo`),
    content: `${dataTestId}.content`,
  };
};

export interface HeaderProps {
  backButton?: React.ReactNode;
  hamburgerMenu?: React.ReactNode;
  children?: React.ReactNode;
  dataTestId?: string;
}

const Header: React.FC<HeaderProps> = memo(({ backButton, hamburgerMenu, children, dataTestId }: HeaderProps) => {
  const { partner } = useTheme();
  const allDataTestId = makeDataTestId(dataTestId);

  return (
    <HeaderContainer data-testid={allDataTestId.wrapper}>
      <MaxWidthContainer>
        <HeaderGrid container alignItems="center">
          {backButton ? (
            <Grid xs="auto" sx={{ marginInlineEnd: 1 }} data-testid={allDataTestId.backButton}>
              <Stack direction="row" gap={1} alignItems="center">
                {backButton}
              </Stack>
            </Grid>
          ) : (
            <></>
          )}
          {hamburgerMenu}
          <LogoGrid xs>
            <PartnerLogo
              dataTestId={allDataTestId.logo.prefix}
              alt={`${partner.name} brand logo`}
              src={partner.header.brandLogo ?? partner.brandLogo}
            />
          </LogoGrid>
          <Grid xs="auto" alignItems="center">
            <Stack direction="row" gap={1} alignItems="center">
              {children}
            </Stack>
          </Grid>
        </HeaderGrid>
      </MaxWidthContainer>
    </HeaderContainer>
  );
});

export default Header;
